import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DescargaConsolidadosDto } from '../dto/integrador/descarga-consolidados.dto';
import { ListadoFormulariosPaginadoDto } from '../dto/integrador/listado-formularios-paginado.dto';

@Injectable({
  providedIn: 'root',
})
export class FormulariosEnviadosService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/integrador';

  constructor(private http: HttpClient) {}

  listadoConsolidado(params: any) {
    return this.http.get<ListadoFormulariosPaginadoDto>(
      `${this.apiUrl}${this.baseUrl}/obtenerEstadisticasConsolidado`,
      {
        params: {
          idEntidad: params.idEntidad,
          anio: params.anio,
          mes: params.mes,
          fecha: params.fecha,
          page: params.page,
          limit: params.limit,
        },
      }
    );
  }

  descargarConsolidados(request: DescargaConsolidadosDto[]): Observable<any> {
    return this.http.post<ArrayBuffer>(
      `${this.apiUrl}${this.baseUrl}/descargarConsolidados`,
      request,
      { responseType: 'json' }
    );
  }
}
